module.exports = __webpack_public_path__ + "static/media/1024px.e3a500ec.png";